import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  MessageModalComponent,
  MessageModalType,
} from '@shared/components/message-modal/message-modal.component';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

interface ErrorResponseData {
  statusCode: number;
  message: string;
  detail?: string;
  timestamp: string;
  path: string;
}

interface ErrorResponse {
  error: ErrorResponseData;
}

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(public dialog: MatDialog) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((responseError: ErrorResponse) => {
        this.openMessageModal(responseError.error); // Chame a função para exibir o modal de erro
        return throwError(() => responseError);
      })
    );
  }

  openMessageModal(error: ErrorResponseData): void {
    if (
      error &&
      error.message != 'Internal server error' &&
      error.statusCode !== 401
    )
      this.dialog.open(MessageModalComponent, {
        data: {
          title: 'Falha na operação',
          message: error.message,
          additionalNote: error.detail,
          confirmText: 'Confirmar',
          cancelText: 'Cancelar',
          showCancel: false,
          type: MessageModalType.ERROR,
        },
      });
  }
}
